// extracted by mini-css-extract-plugin
export default {"root":"Header-root-dd0b","logo":"Header-logo-ec34","nav":"Header-nav-d311","title":"Header-title-e78a","login":"Header-login-a513"};